var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.462 36.2393C48.948 34.404 47.916 32.788 46.5307 31.5527L43.4653 34.618C44.5833 35.528 45.3373 36.8673 45.4747 38.3833V39.3887C45.492 39.3887 45.508 39.3833 45.5253 39.3833C47.0733 39.3833 48.3333 40.6433 48.3333 42.1913C48.3333 43.7393 47.0733 45 45.5253 45C45.508 45 45.492 44.9953 45.4747 44.9947V45H41.0307H40V49.3333H45.4747V49.3307C45.492 49.3307 45.508 49.3333 45.5253 49.3333C49.4633 49.3333 52.6667 46.1293 52.6667 42.192C52.6667 39.7087 51.3907 37.5193 49.462 36.2393Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.04 41.06L40.1867 37.9133C40.184 37.91 40.1813 37.9073 40.1793 37.9047L37.0347 41.0493C37.036 41.0527 37.038 41.056 37.04 41.06Z",
    fill: "#FFE082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.04 41.06L40.1867 37.9133C40.184 37.91 40.1813 37.9073 40.1793 37.9047L37.0347 41.0493C37.036 41.0527 37.038 41.056 37.04 41.06Z",
    fill: "#90CAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 29.0507C34.578 29.0507 30.1667 33.462 30.1667 38.884C30.1667 39.0393 30.1827 39.1907 30.19 39.344H34.5234C34.5107 39.192 34.5 39.0393 34.5 38.884C34.5 35.8513 36.9674 33.384 40 33.384C41.3127 33.384 42.5187 33.848 43.4654 34.618L46.5307 31.5527C44.792 30.002 42.5074 29.0507 40 29.0507Z",
    fill: "#FF3D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.4747 45H34.4733C34.066 45 33.6813 44.9087 33.332 44.7513L30.192 47.8913C31.3873 48.792 32.8673 49.3333 34.4733 49.3333H34.4747H40V45H34.4747Z",
    fill: "#90CAF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4747 45H34.4733C34.066 45 33.6813 44.9087 33.332 44.7513L30.192 47.8913C31.3873 48.792 32.8673 49.3333 34.4733 49.3333H34.4747H40V45H34.4747Z",
    fill: "#4CAF50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 42.1933C31.6666 40.6467 32.9266 39.3867 34.4733 39.3867C35.6086 39.3867 36.592 40.0687 37.034 41.0493L40.1786 37.9047C38.8713 36.17 36.802 35.0533 34.4726 35.0533C30.54 35.0533 27.3333 38.2533 27.3333 42.1933C27.3333 44.5207 28.4606 46.5867 30.192 47.8913L33.332 44.7513C32.3533 44.3127 31.6666 43.3327 31.6666 42.1933Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.074a658c0e5771d928d8ec106ed8ec6d.svg";
export { ForwardRef as ReactComponent };